import {
  buttonsLabels,
  roles,
  subRoles,
  subRolesCheckbox,
  userStatusSelect,
} from "../../../utils/constants";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { HiOutlineMail } from "react-icons/hi";
import { userHasLevel } from "../../../engine/AuthRoute";

export const InstitutionsUserForms = ({ user, isFirst }) => {
  const { user: userId } = useParams();

  const [subRoleitemDisabled, setSubRoleitemDisabled] = useState([]);

  const {
    info: { firstname, lastname, genre, phone, title },
    comment,
    status,
    email,
  } = user;

  useEffect(() => {
    if (
      user.subRoles !== null &&
      user.subRoles.length > 0 &&
      user.subRoles.includes(subRoles.institutionAdmin)
    ) {
      setSubRoleitemDisabled([
        subRoles.institutionDemander,
        subRoles.institutionFinance,
      ]);
    }
  }, [user.subRoles]);

  return [
    {
      parentLabel: "",
      children: [
        {
          label: "Nom",
          name: "info.lastname",
          capitalize: true,
          value: lastname,
          type: "input",
          required: true,
          col: 24,
        },
        {
          label: "Prénom",
          name: "info.firstname",
          value: firstname,
          capitalize: true,
          required: true,
          type: "input",
          col: 24,
        },
        {
          label: "Fonction",
          name: "info.title",
          watchValues: [
            subRoles.institutionDemander,
            subRoles.institutionAdmin,
            subRoles.institutionFinance,
          ],
          watchRequiredCondition: true,
          watch: "subRoles",
          value: title,
          type: "input",
          required: true,
          col: 24,
        },
        // {
        //   label: "Genre",
        //   name: "info.genre",
        //   value: genre,
        //   required: true,
        //   type: "select",
        //   selectContent: [
        //     { label: "Homme", value: "male" },
        //     { label: "Femme", value: "female" },
        //   ],
        //   col: 24,
        // },
        {
          label: "E-mail",
          required: true,
          name: "email",
          normalize: value => value && value.toLowerCase(),
          addonBefore: <HiOutlineMail />,
          value: email,
          type: "email",
          col: 24,
        },
        {
          label: "Téléphone",
          name: "info.phone",
          value: phone,
          type: "input",
          col: 24,
        },
        {
          label: "Remarque",
          name: "comment",
          value: comment,
          visible: userHasLevel({
            not: {
              [roles.interprete]: "r", //
            },
          }),
          type: "textarea",
          col: 24,
        },
        userId !== "new"
          ? {
              label: "Accès autorisé",
              name: "status",
              value: status,
              required: true,
              type: "select",
              selectContent: userStatusSelect(),
              col: 24,
            }
          : null,
      ],
    },
    {
      parentLabel: "Roles",
      children: [
        {
          label: "",
          name: "subRoles",
          value: user.subRoles,
          type: "checkbox",
          onChange: props => {
            const { ref, value } = props;
            if (value.includes(subRoles.institutionAdmin)) {
              ref.current.setFieldsValue({
                subRoles: [
                  subRoles.institutionAdmin,
                  subRoles.institutionDemander,
                  subRoles.institutionFinance,
                ],
              });

              setSubRoleitemDisabled([
                subRoles.institutionDemander,
                subRoles.institutionFinance,
              ]);
            } else {
              setSubRoleitemDisabled([]);
            }
          },
          itemDisabled: subRoleitemDisabled,
          checkboxs: subRolesCheckbox,
          col: 24,
        },
      ],
    },
    {
      children: [
        {
          label: userId === "new" ? "Créer l'utilisateur" : buttonsLabels.save,
          name: "send",
          value: "send",
          type: "submit",
          col: 24,
          align: "right",
        },
      ],
    },
  ];
};
